import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';

export default function MembershipPlansEditor({ plans, onChange }) {
  const addPlan = () => onChange([...plans, { name: '', price: '', duration: '' }]);
  const removePlan = (i) => onChange(plans.filter((_, idx) => idx !== i));
  const updatePlan = (i, field, value) =>
    onChange(plans.map((p, idx) => (idx === i ? { ...p, [field]: value } : p)));

  return (
    <div className="space-y-2">
      {plans.map((plan, i) => (
        <div key={i} className="flex gap-2 items-center">
          <input type="text" placeholder="Plan name" value={plan.name}
            onChange={e => updatePlan(i, 'name', e.target.value)}
            className="flex-1 px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-red-500" />
          <input type="number" placeholder="₹ Price" value={plan.price}
            onChange={e => updatePlan(i, 'price', e.target.value)}
            className="w-24 px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-red-500" />
          <input type="text" placeholder="Duration" value={plan.duration}
            onChange={e => updatePlan(i, 'duration', e.target.value)}
            className="w-28 px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-red-500" />
          <button type="button" onClick={() => removePlan(i)} className="text-red-400 hover:text-red-600 p-1">
            <TrashIcon className="h-4 w-4" />
          </button>
        </div>
      ))}
      <button type="button" onClick={addPlan}
        className="flex items-center gap-1 text-xs text-red-600 hover:text-red-800 font-medium mt-1">
        <PlusIcon className="h-3 w-3" /> Add Plan
      </button>
    </div>
  );
}
